import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers} from "./config";

const InventoryPricingList = () => {

  return (
    <Table tableId={`inventory_pricing`} title="Inventory Pricing" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="length" idKey="inventory_pricing_id" NoTitle={true} />
  );
};

export default InventoryPricingList;